export type LeaderboardPageHeroKey = 'performance-index' | 'depth' | 'volume' | 'spread' | 'kpi'

export interface LeaderboardPageHeroContent {
  headTitle: string
  seoTitle: string
  title: string
  description: string
}

export const leaderboardPageHero: Record<LeaderboardPageHeroKey, LeaderboardPageHeroContent> = {
  'performance-index': {
    headTitle: 'Performance Index',
    seoTitle: 'Analyze Market Maker Performance with Forgd',
    title: 'Forgd Market Maker Performance Index Leaderboard',
    description:
      'Data-driven Market Maker rankings derived from 500+ engagements, evaluating historical execution, reliability, and ecosystem integration.',
  },
  'depth': {
    headTitle: 'Depth Leaderboard',
    seoTitle: 'Depth Leaderboard | Forgd',
    title: 'Forgd Market Depth Leaderboard',
    description:
      'See how Market Makers rank based on Depth KPIs such as the avg. value of bid & ask as well as percentage of market share.',
  },
  'volume': {
    headTitle: 'Volume Leaderboard',
    seoTitle: 'Volume Leaderboard | Forgd',
    title: 'Forgd Market Maker Volume Leaderboard',
    description:
      'See how Market Makers rank based on Volume KPIs such as the avg. daily fill volume (maker & taker) as well as percentage of market share.',
  },
  'spread': {
    headTitle: 'Spread Leaderboard',
    seoTitle: 'Spread Leaderboard | Forgd',
    title: 'Forgd Market Maker Spread Leaderboard',
    description:
      'See how Market Makers rank based on Spread KPIs such as the avg. top-of-book spread as well as their adherence to contractual obligations.',
  },
  'kpi': {
    headTitle: 'KPI Adherence Leaderboard',
    seoTitle: 'KPI Adherence Leaderboard | Forgd',
    title: 'Forgd Market Maker KPI Adherence Leaderboard',
    description:
      'See how Market Makers rank based on adherence to contractual obligations.',
  },
}

export const leaderboardDocumentationPath = '/market-maker-leaderboard/documentation'
export const leaderboardHowItWorksPath = `${leaderboardDocumentationPath}/how-it-works`

export function useLeaderboardPageHero(page: LeaderboardPageHeroKey): LeaderboardPageHeroContent {
  const content = leaderboardPageHero[page]

  useHead({ title: content.headTitle })

  return content
}
